import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Bell, Check, FileWarning } from 'lucide-react';
import useAccountStore from '../../store/useAccountStore';

const NotificationCenter = () => {
  const { notifications, fetchMyNotifications, markNotificationAsRead } = useAccountStore();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    fetchMyNotifications();
  }, [fetchMyNotifications]);

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setIsOpen((value) => !value)}
        className="relative p-3 bg-white border border-slate-100 rounded-2xl text-slate-500 hover:text-slate-900 hover:shadow-sm transition-all"
        title="Bildirimler"
      >
        <Bell size={20} />
        {notifications.length > 0 && (
          <span className="absolute -top-1 -right-1 min-w-5 h-5 px-1 rounded-full bg-rose-600 text-white text-[10px] font-black flex items-center justify-center border-2 border-slate-50">
            {notifications.length}
          </span>
        )}
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-3 w-96 max-w-[calc(100vw-2rem)] bg-white border border-slate-100 shadow-2xl rounded-3xl overflow-hidden z-50">
          <div className="px-5 py-4 border-b border-slate-50">
            <p className="text-sm font-black text-slate-800">Operasyon Bildirimleri</p>
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Son 5 bildirim</p>
          </div>

          <div className="max-h-96 overflow-y-auto">
            {notifications.length === 0 ? (
              <div className="p-8 text-center text-slate-400">
                <Bell size={28} className="mx-auto mb-3 text-slate-200" />
                <p className="text-xs font-bold">Okunmamış bildiriminiz yok.</p>
              </div>
            ) : (
              notifications.map((item) => (
                <div key={item._id} className="p-4 border-b border-slate-50 last:border-none flex gap-3">
                  <div className="w-10 h-10 rounded-2xl bg-rose-50 text-rose-600 flex items-center justify-center shrink-0">
                    <FileWarning size={18} />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-xs font-black text-slate-800">{item.title}</p>
                    <p className="text-[11px] font-medium text-slate-500 mt-1 leading-relaxed">{item.message}</p>
                    <p className="text-[10px] font-bold text-slate-400 mt-2">
                      {item.account?.name || 'Cari'} • {new Date(item.createdAt).toLocaleDateString('tr-TR')}
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={() => markNotificationAsRead(item._id)}
                    className="p-2 h-fit rounded-xl text-emerald-600 hover:bg-emerald-50 transition-colors"
                    title="Okundu işaretle"
                  >
                    <Check size={16} />
                  </button>
                </div>
              ))
            )}
          </div>
          <div className="border-t border-slate-50 p-3">
            <Link
              to="/notifications"
              onClick={() => setIsOpen(false)}
              className="block rounded-2xl bg-slate-900 px-4 py-3 text-center text-[10px] font-black uppercase tracking-widest text-white transition hover:bg-black"
            >
              Tümünü Gör
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationCenter;
